export default class StorageProvider {
  constructor(storageProvider, saveItemFun, getItemFunc, removeItemFunc, prefix, keys) {
    this.storageProvider = storageProvider;
    this.saveItemFun = saveItemFun;
    this.getItemFunc = getItemFunc;
    this.removeItemFunc = removeItemFunc;
    this.prefix = prefix;
    this.keys = keys;
  }

  saveElement(key, value) {
    this.saveItemFun(this.storageProvider, `${this.prefix}-${this.keys[key]}`, value);
  }

  getElement(key) {
    return this.getItemFunc(this.storageProvider, `${this.prefix}-${this.keys[key]}`);
  }

  removeElement(key) {
    this.removeItemFunc(this.storageProvider, `${this.prefix}-${this.keys[key]}`);
  }
}
